import React from 'react';
import { HOYA_COMPANY_ID } from '../../../const';
import { Translate } from '../../../services/translationService/components/Translate';

export const cookieHeaders = [
    {
        title: <Translate.Text value={ 'page.cookiePolicy.cookieTable.header.cookieTypes' } />,
        dataIndex: 'type',
        key: 'type',
        render: ( translationKey ) => (
            <Translate.Text value={ translationKey } />
        ),
        width: '240px',
    },
    {
        title: <Translate.Text value={ 'page.cookiePolicy.cookieTable.header.cookieNames' } />,
        dataIndex: 'names',
        key: 'names',
        render: ( data ) => data.map( ( name, index ) => (
            // Name value intentionally not translated.
            <div key={ `name-${ index }` }><small>{ name }</small></div>
        ) ),
        width: '180px',
    },
    {
        title: <Translate.Text value={ 'page.cookiePolicy.cookieTable.header.purpose' } />,
        dataIndex: 'purpose',
        key: 'purpose',
        render: ( translationKey ) => (
            <Translate.Text value={ translationKey } />
        ),
    },
    {
        title: <Translate.Text value={ 'page.cookiePolicy.cookieTable.header.storedData' } />,
        dataIndex: 'cookieData',
        key: 'cookieData',
        render: ( data ) => <ul className="cookie-table-data-list">{
            data.map( ( translationKey, index ) => (
                <li key={ `data-${ index }` }><small>
                    <Translate.Text value={ translationKey } />
                </small></li>
            ) )
        }</ul>,
        width: '180px',
    },
];

const COOKIE_NAME_SITE_URL = document?.location?.origin || '{siteUrl}';

export const cookieTables = [
    {
        key: 'chameleonCookie',
        type: 'page.cookiePolicy.cookieTable.cookieTypes.javascript',
        names: [ 'chameleonID' ],
        purpose: 'page.cookiePolicy.cookieTable.entry.chameleonCookie.purpose',
        cookieData: [
            'page.cookiePolicy.cookieTable.entry.chameleonCookie.data.0',
        ],
    },
    {
        key: 'authState',
        type: 'page.cookiePolicy.cookieTable.cookieTypes.authentication',
        names: [ `_state.${ COOKIE_NAME_SITE_URL }` ],
        purpose: 'page.cookiePolicy.cookieTable.entry.authState.purpose',
        cookieData: [
            'page.cookiePolicy.cookieTable.entry.common.data.verificationKey',
        ],
    },
    {
        key: 'authStateSig',
        type: 'page.cookiePolicy.cookieTable.cookieTypes.authentication',
        names: [ `_state.${ COOKIE_NAME_SITE_URL }.sig` ],
        purpose: 'page.cookiePolicy.cookieTable.entry.authStateSig.purpose',
        cookieData: [
            'page.cookiePolicy.cookieTable.entry.common.data.verificationKey',
        ],
    },
    {
        key: 'authSession',
        type: 'page.cookiePolicy.cookieTable.cookieTypes.authentication',
        names: [ `_session.${ HOYA_COMPANY_ID }` ],
        purpose: 'page.cookiePolicy.cookieTable.entry.authSession.purpose',
        cookieData: [
            'page.cookiePolicy.cookieTable.entry.authSession.data.0',
        ],
    },
    {
        key: 'authSessionSig',
        type: 'page.cookiePolicy.cookieTable.cookieTypes.authentication',
        names: [ `_session.${ HOYA_COMPANY_ID }.sig` ],
        purpose: 'page.cookiePolicy.cookieTable.entry.authSessionSig.purpose',
        cookieData: [
            'page.cookiePolicy.cookieTable.entry.common.data.verificationKey',
        ],
    },
    {
        key: 'authLogoutHint',
        type: 'page.cookiePolicy.cookieTable.cookieTypes.authentication',
        names: [ `_logout-hint.${ HOYA_COMPANY_ID }` ],
        purpose: 'page.cookiePolicy.cookieTable.entry.authLogoutHint.purpose',
        cookieData: [
            'page.cookiePolicy.cookieTable.entry.authLogoutHint.data.0',
        ],
    },
    {
        key: 'authLogoutHintSig',
        type: 'page.cookiePolicy.cookieTable.cookieTypes.authentication',
        names: [ `_logout-hint.${ HOYA_COMPANY_ID }.sig` ],
        purpose: 'page.cookiePolicy.cookieTable.entry.authLogoutHintSig.purpose',
        cookieData: [
            'page.cookiePolicy.cookieTable.entry.common.data.verificationKey',
        ],
    }
];
